import { useTranslation } from 'react-i18next';
import { ChevronRight } from 'lucide-react';

import { Image, Paragraph } from '@app/shared/ui/atoms/Common';
import { wisdomPanda } from '@app/assets';

export const StonesBannerDescription = () => {
  const { t } = useTranslation();

  return (
    <div className="relative flex-1">
      <Paragraph size="xl" className="font-semibold" variant="secondary">
        {t('shop.energy_stones')}
      </Paragraph>
      <Paragraph
        variant="accent"
        className="whitespace-pre-line pr-[4px] text-2xs font-semibold sm:text-xs"
      >
        {t('cognition.stones_banner_description')}
      </Paragraph>
      <Image src={wisdomPanda} alt="wisdom panda" className="absolute -left-[9px] bottom-0" />
      <div className="absolute bottom-2 flex size-[32px] items-center justify-center rounded-2xl bg-white/40 backdrop-blur-[9.6px]">
        <ChevronRight className="text-foreground" />
      </div>
    </div>
  );
};
